const modalService = () => {
  const body = document.querySelector("body");
  const buttons = document.querySelectorAll("[data-modal-trigger]");

  for (let button of buttons) {
    triggerEvent(button);
  }

  function triggerEvent(button) {
    button.addEventListener("click", () => {
      const trigger = button.getAttribute("data-modal-trigger");
      const modal = document.querySelector(`[data-modal=${trigger}]`);
      const modalBody = modal.querySelector(".simple-modal-body");
      const closeBtn = modal.querySelector(".simple-modal-close");

      closeBtn.addEventListener("click", () =>
        modal.classList.remove("is-open")
      );
      modal.addEventListener("click", () => modal.classList.remove("is-open"));

      modalBody.addEventListener("click", (e) => e.stopPropagation());

      modal.classList.toggle("is-open");

      body.addEventListener("keydown", (e) => {
        if (e.keyCode === 27) {
          modal.classList.remove("is-open");
        }
      });
    });
  }
};

modalService();
